type Context={token:string;signal:AbortSignal;onWaiting?:()=>void};
// Only the server's closed/expired tombstone proves that an old invocation
// cannot still write. Never infer this from elapsed time, HTTP status or HEAD.
export async function uploadTicketIsSettled(id:string,digest:string,size:number,context:Context){
 try{
  for(let poll=0;poll<4;poll++){
   context.signal.throwIfAborted();
   const r=await fetch('/api/uploads/admission',{method:'POST',headers:{authorization:`Bearer ${context.token}`,'content-type':'application/json'},body:JSON.stringify({id,digest,size}),signal:AbortSignal.any([context.signal,AbortSignal.timeout(15000)])});
   const result=await r.json() as {id?:string;status?:string};
   if(!r.ok||result.id!==id)return false;
   if(['closed','expired'].includes(result.status||''))return true;
   if(result.status!=='active')return false;
   if(poll<3){context.onWaiting?.();await pause(context.signal,1500);}
  }
 }catch{context.signal.throwIfAborted();}
 return false;
}
const pause=(signal:AbortSignal,ms:number)=>new Promise<void>((resolve,reject)=>{signal.throwIfAborted();const abort=()=>{clearTimeout(timer);reject(signal.reason);};const timer=setTimeout(()=>{signal.removeEventListener('abort',abort);resolve();},ms);signal.addEventListener('abort',abort,{once:true});});
export async function acquireUploadTicket(digest:string,size:number,context:Context){
 let id=crypto.randomUUID(),submitted=false,transientErrors=0;
 try{
  for(let poll=0;poll<450;poll++){
   context.signal.throwIfAborted();submitted=true;
   let response:Response;
   try{response=await fetch('/api/uploads/admission',{method:'POST',headers:{authorization:`Bearer ${context.token}`,'content-type':'application/json'},body:JSON.stringify({id,digest,size,wait:true}),signal:AbortSignal.any([context.signal,AbortSignal.timeout(45000)])});}
   catch(error){context.signal.throwIfAborted();if(++transientErrors>3)throw error;context.onWaiting?.();await pause(context.signal,2000);continue;}
   const body=await response.json().catch(()=>({})) as {enabled?:boolean;id?:string;status?:string;error?:string;retryAfterMs?:number;waited?:boolean};
   if(body.error==='cloud_upload_daily_limit'){submitted=false;throw new Error(body.error);}
   if(response.status>=500&&++transientErrors<=3){context.onWaiting?.();await pause(context.signal,2000);continue;}
   if(response.ok)transientErrors=0;
   if(response.status===404||response.ok&&body.enabled===false)return null;
   if(response.status===429){context.onWaiting?.();await pause(context.signal,4000+Math.random()*1500);continue;}
   if(!response.ok)throw new Error(body.error||'cloud_upload_queue_unavailable');
   if(body.id!==id)throw new Error('cloud_upload_ticket_invalid');
   if(body.status==='reserved')return id;
   if(body.status==='expired'||body.status==='closed'){id=crypto.randomUUID();continue;}
   if(body.status!=='queued')throw new Error('cloud_upload_in_progress');
   context.onWaiting?.();
   await pause(context.signal,body.waited?100+Math.random()*250:Math.max(1000,body.retryAfterMs||4000)+Math.random()*1000);
  }throw new Error('cloud_upload_wait_timeout');
 }catch(error){
  // Cancellation can remove only waiting/reserved metadata. An active upload
  // belongs to its server invocation and is never released by the browser.
  if(submitted)void fetch('/api/uploads/admission',{method:'POST',headers:{authorization:`Bearer ${context.token}`,'content-type':'application/json'},body:JSON.stringify({id,action:'cancel'}),signal:AbortSignal.timeout(3000)}).catch(()=>undefined);
  throw error;
 }
}
